import { createSlice } from '@reduxjs/toolkit';

const authFormSlice = createSlice({
    name: 'authForm',
    initialState: {
        isLogin: true,
        isOpen: false
    },
    reducers: {
        openFormLogin: (state, action) => {
            return {
                ...state,
                isLogin: true,
                isOpen: true
            }
        },
        openFormRegister: (state, action) => {
            return {
                ...state,
                isLogin: false,
                isOpen: true
            }
        },
        closeForm: (state, action) => {
            return {
                ...state,
                isOpen: false
            }
        },
    }
});

const { reducer, actions } = authFormSlice
export const {openFormLogin, openFormRegister, closeForm} = actions
export default reducer